import { I18nProvider, useI18nContext } from '@cmg/i18n';
import { FC, PropsWithChildren, useEffect } from 'react';

import { useStoredUserSettings } from '../../features/settings/storedUserSettings';

// Syncs the stored user locale into the I18nProvider context without remounting the tree.
// Using key={locale} on I18nProvider would remount the entire subtree on locale change, which
// cancels in-flight sagas (e.g. the OIDC login callback saga mid-execution).
const LocaleSyncer: FC = () => {
  const [{ locale }] = useStoredUserSettings();
  const { switchLocale } = useI18nContext();

  useEffect(() => {
    switchLocale(locale);
  }, [locale, switchLocale]);

  return null;
};

export const XcI18nProvider: FC<PropsWithChildren> = ({ children }) => {
  const [{ locale }] = useStoredUserSettings();

  const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return (
    <I18nProvider initialLocale={locale} timeZone={browserTimeZone}>
      <LocaleSyncer />
      {children}
    </I18nProvider>
  );
};
